module.exports = __webpack_public_path__ + "media/images/static/top/urban/building_left-defc59d3772188cb8f36ff12d9a7d9dd.png";